import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable no-restricted-syntax */
import { debounce, isEqual } from "lodash-es";
import { Vue, Prop, Component } from 'vue-property-decorator';
import { cssTextToStyleObject, styleObjectToCssText } from "../../lib/utils/styling";
import ExprInput from './ExprInput';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/css/css';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/hint/show-hint.css';
import ExprInputCompletionProvider from './ExprInput/ExprInputCompletionProvider';
import { installCodeMirrorColorWidget } from './ExprInput/addon/uicore-css-color-widget';
import { installCodeMirrorCssInlineWidget } from "../../lib/comps/ExprInput/addon/uicore-css-inline-widget";
let CSSEditor = class CSSEditor extends Vue {
  constructor() {
    super(...arguments);
    this.text = '';
    // 0: not focused
    // 1: focused, not changed
    // 2: focused, outside changed (when blur, we must reset)
    // 3: focused, we changed
    this.focusStatus = 0;
  }
  created() {
    this.$watch(() => styleObjectToCssText(this.value), text => {
      if (text === this.text) return;
      if (this.focusStatus === 1) this.focusStatus = 2;else this.text = text;
    }, {
      immediate: true
    });
    this.$watch(() => this.enableInlineCheckBox, () => {
      var _this$updateInlineChe;
      (_this$updateInlineChe = this.updateInlineCheckBox) === null || _this$updateInlineChe === void 0 || _this$updateInlineChe.call(this);
    });
  }
  get debouncedEmitValue() {
    return debounce(() => {
      if (this.focusStatus !== 3) return;
      this.focusStatus = 1;
      const styleObj = cssTextToStyleObject(this.text);
      if (isEqual(styleObj, this.value)) return;
      this.$emit('change', styleObj);
    });
  }
  beforeDestroy() {
    this.debouncedEmitValue.flush();
  }
  handleChange(value) {
    this.text = value;
    this.focusStatus = 3;
    this.debouncedEmitValue();
  }
  handleFocus() {
    this.focusStatus = 1;
  }
  handleBlur() {
    if (this.focusStatus === 3) {
      this.debouncedEmitValue.flush();
    } else {
      this.text = styleObjectToCssText(this.value);
    }
    this.focusStatus = 0;
  }
  handleCmReady(cm) {
    installCodeMirrorColorWidget(cm, () => {
      const inputNode = this.$refs.exprInput;
      inputNode === null || inputNode === void 0 || inputNode.commitDebounced();
      inputNode === null || inputNode === void 0 || inputNode.commitDebounced.flush();
    });
    if (this.getInlineCheckBoxNode) {
      this.updateInlineCheckBox = installCodeMirrorCssInlineWidget(cm, this.getInlineCheckBoxNode);
    }
    cm.addKeyMap({
      Enter: () => {
        cm.operation(() => {
          var _cm$getTokenAt;
          const pos = cm.getCursor();
          if (/\binteropPart\b/.test((_cm$getTokenAt = cm.getTokenAt(pos)) === null || _cm$getTokenAt === void 0 ? void 0 : _cm$getTokenAt.type)) {
            cm.execCommand('newlineAndIndent');
            return;
          }
          const lineRemain = cm.getLine(pos.line);
          if (/\s*;\s*$|^\s*$/.test(lineRemain.slice(0, pos.ch))) {
            cm.execCommand('newlineAndIndent');
          } else {
            cm.replaceSelection(';\n');
            cm.setCursor({
              line: pos.line + 1,
              ch: 0
            });
          }
        });
      }
    }, false);
  }
  render() {
    const h = arguments[0];
    return h(ExprInputCompletionProvider, {
      "attrs": {
        "customMethodForRaw": completion
      }
    }, [h(ExprInput, {
      "ref": 'exprInput',
      "attrs": {
        "popupTitle": "CSS样式编辑",
        "multipleLine": true,
        "type": "interopable-string",
        "cmOptions": cmOptions,
        "value": this.text,
        "readonly": this.readonly
      },
      "on": {
        "cmReady": this.handleCmReady,
        "focus": this.handleFocus,
        "blur": this.handleBlur,
        "change": this.handleChange
      }
    })]);
    // return <CSSEditorText
    //   owner={this}
    //   multipleLine
    // />;
  }
};
__decorate([Prop({
  type: Object
})], CSSEditor.prototype, "value", void 0);
__decorate([Prop({
  type: Function
})], CSSEditor.prototype, "getInlineCheckBoxNode", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], CSSEditor.prototype, "enableInlineCheckBox", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], CSSEditor.prototype, "readonly", void 0);
CSSEditor = __decorate([Component({
  name: 'CSSEditor',
  model: {
    prop: 'value',
    event: 'change'
  }
})], CSSEditor);
const cmOptions = {
  mode: {
    name: 'interopable-css',
    inline: true
  }
};
const cssLangMeta = CodeMirror.mimeModes['text/css'];
const propertyKeywords = Object.keys(cssLangMeta.propertyKeywords);
const clue2regex = clue => {
  let re = '^';
  clue.toLowerCase().split('').forEach(x => {
    if (x >= 'a' && x <= 'z') re += `${x}(.*)`;
  });
  if (re.length === 1) return /^$/;
  return new RegExp(re, 'i');
};
const completion = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator(function* (req) {
    const {
      cm,
      cursor: pos
    } = req;
    const line = cm.getLine(pos.line);
    const leading = line.slice(0, pos.ch).trimLeft();
    const colonPos = line.match(/:\s*/);
    const from = CodeMirror.Pos(pos.line, 0);
    const to = !colonPos ? pos : CodeMirror.Pos(pos.line, colonPos.index + colonPos[0].length);
    if (!leading.includes(':')) {
      const re = clue2regex(leading);
      const results = propertyKeywords.map(prop => {
        const mat = re.exec(prop);
        if (!mat) return null;
        // 人工智能调整推荐排序
        let loss = 0;
        for (let i = 1; i < mat.length - 1; i++) {
          const part = mat[i];
          loss += part.length;
          if (part.includes('-')) loss *= 0.5;
        }
        loss += prop.length / 1000;
        return {
          loss,
          from,
          to,
          text: `${prop}: `,
          displayText: prop,
          hint(_1, _2, item) {
            var _exec$index, _exec;
            cm.replaceRange(item.text, from, to);
            const newEnd = from.ch + item.text.length;
            const lineRemain = cm.getLine(pos.line).slice(newEnd);
            const selCh = (_exec$index = (_exec = /;/.exec(lineRemain)) === null || _exec === void 0 ? void 0 : _exec.index) !== null && _exec$index !== void 0 ? _exec$index : lineRemain.length;
            cm.setSelection(CodeMirror.Pos(pos.line, newEnd), CodeMirror.Pos(pos.line, newEnd + selCh));
          }
        };
      }).filter(Boolean).sort((a, b) => a.loss - b.loss);
      for (const result of results) {
        if (result) yield result;
      }
    }
  });
  return function completion(_x) {
    return _ref.apply(this, arguments);
  };
}();
export const ExprInputCompletionCSSProvider = completion;
export default CSSEditor;
//# sourceMappingURL=CSSEditor.js.map
